<template>
  <div class="wrapper">
    <nav class="col-md-auto">
      <div class="sidebar d-md-block bg-dark">
        <div class="sidebar-sticky">
          <judging-sidebar-console/>
        </div>
      </div>
    </nav>
    <main role="main">
      <judging-navbar class="container-fluid pr-5"/>
      <div v-if="entry.name">
        <review-show-entry :entry="entry"/>
      </div>
      <!-- v-if -->
    </main>
  </div>
  <!--.wrapper -->
</template>



<script>
import { mapState, mapGetters } from 'vuex'
import JudgingNavbar from '@/components/judging/JudgingNavbar.vue'
import ReviewShowEntry from '@/components/review/ReviewShowEntry.vue'
import JudgingSidebarConsole from '@/components/judging/JudgingSidebarConsole.vue'

export default {
  components: {
    ReviewShowEntry,
    JudgingNavbar,
    JudgingSidebarConsole
  },
  data() {
    return {
      entry: {},
      score: {}
    }
  },
  methods: {
    nextPrev(incrementDecrement) {
      let entriesArray = Object.keys(this.entries)
      let index = this.currentEntry(this.$route.params.ceid)
      index !== -1
        ? this.$router.push({
            name: 'completed-entry',
            params: { ceid: entriesArray[index + incrementDecrement] }
          })
        : this.$router.push({ name: 'completed-entries' })
      window.scrollTo(0, 0)
    },
    updateViewed() {
      let payload = {
        doc: this.$route.params.ceid,
        currentJudge: this.$store.state.currentUser
      }
      console.log(payload)
      this.$store.dispatch('judging/updateViewed', payload)
    },
    updateDB() {
      let payload = {
        scoreOb: { ...this.score }
      }
      console.log('updateDB: ' + JSON.stringify(payload))
      payload.entryID = this.$route.params.ceid
      payload.scoreOb.total = this.currentScore(this.$route.params.ceid)
      return this.$store.dispatch('judging/updateDB', payload)
    }
  },
  computed: {
    ...mapState({
      // entrants: state => state.admin.entrands
      entries: state => state.judging.entries,
      currentJudge: state => state.currentUser
    }),
    ...mapGetters({
      entryCount: 'judging/entryCount',
      currentEntry: 'judging/currentEntry',
      currentScore: 'judging/currentScore'
    }),
    entryIndex: function() {
      let entriesArray = Object.keys(this.entries)
      let index = entriesArray.findIndex(
        needle => needle == this.$route.params.ceid
      )
      return index
    }
  },
  mounted() {
    let entryKey = this.$route.params.ceid
    // console.log(this.entries[key])
    this.entry = this.entries[entryKey]

    let scoreKey = this.currentJudge
    this.score = this.entry.scores[scoreKey]
    const that = this
    window.onscroll = function() {
      var d = document.documentElement
      const scrollTop = Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
      )
      var offset = scrollTop + window.innerHeight
      var height = d.offsetHeight
      /*
      console.log('offset = ' + offset)
      console.log('height = ' + height)
      console.log(scrollTop + window.innerHeight)

      console.log('documentElement: ' + document.documentElement.scrollTop)
*/
      if (offset === height) {
        console.log('At the bottom')
        if (!that.score.viewed) {
          console.log('unseen')
          that.updateViewed()
        }
      }
    }
  },

  //updateScore(judgeID, scoreOb, entryID)
  beforeRouteUpdate(to, from, next) {
    this.updateDB().then(() => next())
  },
  beforeRouteLeave(to, from, next) {
    console.log('Juding Entry: ' + this.$route.params.ceid)
    this.updateDB().then(() => next())
  }
}
</script>

<style scoped lang="scss">
.nav-review-wrapper {
  position: fixed;
  z-index: 1200;
  right: 0;
  bottom: 0;

  width: 220px;
  .nav-review-controls {
    height: 58px;
    border-top: 1px solid rgba(150, 150, 150, 0.1);
    background-color: rgba(0, 0, 0, 0.05);
    .counter {
      color: rgb(230, 230, 230);
      font-size: 0.8em;
      font-weight: 200;
    }
  }
  .nav-review-buttons {
    height: 80px;
    border-top: 1px solid rgba(100, 100, 100, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    background-color: rgba(0, 0, 0, 0.05);
  }
  .btn {
    /* box-shadow: 2px 0px 6px 3px rgba(0, 0, 0, 0.1) !important;*/
  }
  .nav-review-comments {
    border-top: 1px solid rgba(150, 150, 150, 0.2);
    .nav-review-sub-heading {
      color: rgba(255, 255, 255, 0.7);
    }
    textarea#comment {
      background: none;
      color: rgba(255, 255, 255, 0.7);
      font-weight: 200;
      border: none;
      box-shadow: none;
      + :focus {
        box-shadow: none;
        border: none;
      }
    }
  }
}
@media (min-width: 768px) {
}
</style>
